import { useEffect, useState } from "react";
import { toast } from "sonner";
import { WifiOff, CloudUpload, CloudOff } from "lucide-react";
import { flushQueue, onQueueChange, pendingCount } from "@/lib/offline";
import { flushLocalPhotos, preloadLocalPhotos, pendingLocalPhotos, onLocalPhotosChange } from "@/lib/offlinePhotos";

export function useOnline() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const up = () => setOnline(true), down = () => setOnline(false);
    window.addEventListener("online", up); window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  return online;
}

export default function OfflineBanner() {
  const online = useOnline();
  const [pending, setPending] = useState(pendingCount());
  const [pendingPhotos, setPendingPhotos] = useState(0);

  useEffect(() => onQueueChange(setPending), []);
  useEffect(() => {
    const refresh = () => pendingLocalPhotos().then((l) => setPendingPhotos(l.length));
    preloadLocalPhotos().then(refresh);
    return onLocalPhotosChange(refresh);
  }, []);
  useEffect(() => {
    if (!online) return;
    const run = async () => {
      const r = await flushQueue();
      if (r.sent) toast.success(`${r.sent} constat${r.sent > 1 ? "s" : ""} synchronisé${r.sent > 1 ? "s" : ""} après retour de connexion`);
      const p = await flushLocalPhotos();
      if (p) toast.success(`${p} photo${p > 1 ? "s" : ""} envoyée${p > 1 ? "s" : ""} au serveur`);
    };
    run();
    const t = setInterval(run, 20000);
    return () => clearInterval(t);
  }, [online]);

  const total = pending + pendingPhotos;
  if (online && !total) return null;
  return (
    <div className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 rounded-full px-4 h-11 text-sm shadow-none border ${online ? "bg-white border-dd-blue text-dd-blue" : "bg-dd-night text-white border-dd-night"}`}
      data-testid="offline-banner">
      {!online ? <><WifiOff size={16} /> Hors ligne — la saisie continue, synchronisation au retour du réseau{total ? ` (${pending} constat${pending > 1 ? "s" : ""}, ${pendingPhotos} photo${pendingPhotos > 1 ? "s" : ""} en attente)` : ""}</>
        : <><CloudUpload size={16} className="animate-pulse" /> Synchronisation : {pending} constat{pending > 1 ? "s" : ""}, {pendingPhotos} photo{pendingPhotos > 1 ? "s" : ""}…</>}
      {!online && total > 0 && <CloudOff size={14} className="opacity-70" />}
    </div>
  );
}
